import React from 'react';

import {
	ROOT,
	ADMIN,
	CONTRACTOR,
	PROVIDER,
	USER,
} from 'constants/roles.constant';

const reportsRoute = [
	{
		key: 'reports.reports',
		path: `/reports`,
		component: React.lazy(() => import('views/pages/UnderConstruction')),
		authority: [ROOT, ADMIN, CONTRACTOR, PROVIDER, USER],
	},
	{
		key: 'reports.analytics',
		path: `/analytics`,
		component: React.lazy(() => import('views/pages/UnderConstruction')),
		authority: [ROOT, ADMIN, CONTRACTOR, PROVIDER, USER],
	},
];

export default reportsRoute;
